/* eslint-disable */
import axios from "axios";
import advtable from "../../custom_lib/AiCharts/advenenttable.vue";
import historytab from '../../custom_lib/AiCharts/historytab.vue';
import groupbarchart from '../../custom_lib/AiCharts/groupbarchart.vue';
import grouplinechart from '../../custom_lib/AiCharts/qrygrouplinechart.vue';
import RiskListPopup from "../RiskListPopup/RiskListPopup.vue";

export default{
    name: "riskSummary",
    components: {
        advtable,
        historytab,
        groupbarchart,
        grouplinechart,
        RiskListPopup
    },
    data(){
        return {
            baseUrl: process.env.VUE_APP_Service_URL,
            headerValues: {},
            idToken: "",
            studyId : "",
            selectedSite: "",
            sites:[],
            data: [],
            loader: true,
            studyRisk: [],
            siteRisk: [],
            showRiskListPopup: false,
            riskListTitle:"",

            //chart
            templateId :"",
            grouplinechartkeys:{
                "xaxiskey":"CreatedAt",
                "groupkey":"riskLevelLabel",
                "searchkey":"categoryId",
            },
            customcolors:[
                '#87D37C', '#F22613', '#ABF0FF', '#C1D1FF', '#F5D76E', '#FDAD73'
            ],
            colorcodes:[
                { "color":"#87D37C","type":"Low" },
                { "color":"#F5D76E","type":"Moderate" },
                { "color":"#F22613","type":"High" },
                { "color":"#C1D1FF","type":"Total Outcomes" },
            ],
            lineColors:['#87D37C', '#F5D76E','#F22613','#C1D1FF'],
            groupchartkeys:{
                "xaxiskey":"category",
                "groupkey":"riskLevelLabel",
            },
            datahistory : [],
            historydata: {},    
            historykeys: [],
        }
    },
    async mounted(){
        this.studyId = this.$store.getters.getStudyIs;
        this.idToken = this.$store.getters.getIdToken;
        this.headerValues = {
            headers: {
                Authorization: "Bearer " + this.idToken,
                "Content-Type": "application/json",
            },
        };
         window.addEventListener("studyIdChanged", (event) => {
            console.log("StudyIDChanged into" + event.detail.storage);
            this.listSites();
            this.getScoreInfos();
            this.getStudyRiskScore();
            this.getSiteRiskScore();
            
        });
        await this.listSites();
        await this.getScoreInfos();
        await this.getStudyRiskScore();
        await this.getSiteRiskScore();
    },
    methods :{
        async listSites(){
            try{
            var response = await axios.get(`${this.baseUrl}/management/site/getallsitesbyuser?studyId=${this.studyId}&sortProperty=siteCode&IsDes=false&getAll=false`,this.headerValues);
            this.sites = response.data;
            }
            catch(err){
                console.error("Error in listing sites", err);
            } 
        },
        async getScoreInfos(){
            this.loader = true;
            try{
                var response = await axios.get(`${this.baseUrl}/forms/rbqm/getscoreinfos?StudyId=${this.studyId}&SiteId=${this.selectedSite}`, this.headerValues);
                console.log("getscoreinfos", response.data);
                this.data = response.data.entities;

                //removing unwanted fields from the data
                this.data?.forEach(obj => ['riskScore', 'id', 'studyId','siteId','riskLevelColor','CreatedUserId','LastModifiedAt','LastModifiedUserId','AccountId'].forEach(key => delete obj[key]));
                
                this.loader = false; 
                this.datahistory.push(this.data);
                this.historydata['Home'] = this.data;
                this.historykeys.push('Home');    
            }
            catch(err){
                console.error("Error in getscoreinfos", err);
            }
        },
        async getStudyRiskScore(){
            try{                                                       
                var response = await axios.get(`${this.baseUrl}/forms/rbqm/getscoreinfos?StudyId=${this.studyId}&SiteId=${this.selectedSite}&RiskLevelLabel=High`, this.headerValues);
                console.log("getscoreinfos", response.data);
                this.studyRisk = response.data;   
            }
            catch(err){
                console.error("Error in getscoreinfos", err);
            }
        },
        async getSiteRiskScore(){
            try{       
                                                                         
                var response = await axios.get(`${this.baseUrl}/forms/rbqm/getscoreinfos?StudyId=${this.studyId}&SiteId=${this.selectedSite}&RiskLevelLabel=High&RiskLevelCondition=Greater Than&RiskLevelCount=2`, this.headerValues);
                console.log("getscoreinfos", response.data);
                this.siteRisk = response.data;   
            }
            catch(err){
                console.error("Error in getscoreinfos", err);
            }
        },
        async drilldowncurrentchartforbar(datafromchild){
            console.log("sorteddataforbarchart",datafromchild);
            const lastkey = this.historykeys[this.historykeys.length - 1];
            if(this.historydata[lastkey].length != datafromchild.sortedData.length){
                this.historykeys.push(datafromchild.filterkeyword);
                this.historydata[datafromchild.filterkeyword] = datafromchild.sortedData;
                this.data = this.historydata[datafromchild.filterkeyword];
            }
        },
        async deleteAfterKeyarrays(selectedKey) {
            let index = this.historykeys.indexOf(selectedKey);
            if (index !== -1) {
                this.historykeys = this.historykeys.slice(0, index + 1);
            }
        },
        async deleteAfterKeyvaluearrays(selectedKey) {
            const entries = Object.entries(this.historydata); // Convert the object to an array of entries
            const selectedIndex = entries.findIndex(([key, value]) => key === selectedKey);
            
            // If the key is found, slice the array to keep only the entries up to the selected key
            const newEntries = selectedIndex !== -1 ? entries.slice(0, selectedIndex + 1) : entries;
            
            // Convert the array of entries back into an object
            return Object.fromEntries(newEntries);
        },
        async gotohistorylevel(history){
            this.deleteAfterKeyvaluearrays(history);
            this.deleteAfterKeyarrays(history);
            this.data = this.historydata[history];
        },
        async drillpopupopened(datafromchild) {
            this.drilldata = datafromchild;
            this.drillpopup = true;
        },
        async retaingroupchartvars(groupvars){
            if(groupvars.xaxiskey!="" && groupvars.groupkey!=""){
            this.groupchartkeys = groupvars;
            }
        },
        async exporttoexcell() {
            const worksheet = XLSX.utils.json_to_sheet(this.data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            XLSX.writeFile(workbook, "Query Metrics.xlsx");
        },
        exporttopdf() {
              // Create a temporary container
              const pdfContainer = document.createElement('div');
              const pdfContainer1 = document.createElement('div');
              const pdfContainer2 = document.createElement('div');
              const pdfContainer3 = document.createElement('div');
              const pdfContainer4 = document.createElement('div');
              const pdfContainer5 = document.createElement('div');
        
              const captureArea1 = this.$refs.captureArea1.cloneNode(true);
              const captureArea2 = this.$refs.captureArea2.cloneNode(true);
              const captureArea3 = this.$refs.captureArea3.cloneNode(true);
              const captureArea4 = this.$refs.captureArea4.cloneNode(true);
              const captureArea5 = this.$refs.captureArea5.cloneNode(true);
        
              captureArea2.classList.add('page-break');
              captureArea3.classList.add('page-break');
              captureArea4.classList.add('page-break');
              captureArea5.classList.add('page-break');
              // Append cloned elements to the container
              pdfContainer1.appendChild(captureArea1);
              pdfContainer2.appendChild(captureArea2);
              pdfContainer3.appendChild(captureArea3);
              pdfContainer4.appendChild(captureArea4);
              pdfContainer5.appendChild(captureArea5);
              
              // Optionally style the container for PDF formatting
             
              pdfContainer1.style.width = '200%';
              pdfContainer2.style.width = '200%';
              pdfContainer3.style.width = '200%';
              pdfContainer4.style.width = '200%';
              pdfContainer5.style.width = '100%';
              
              pdfContainer.appendChild(pdfContainer1);
              pdfContainer.appendChild(pdfContainer2);
              pdfContainer.appendChild(pdfContainer3);
              pdfContainer.appendChild(pdfContainer4);
              pdfContainer.appendChild(pdfContainer5);
        
              pdfContainer.style.display = 'block';
              // Set the options for html2pdf
              const opt = {
                margin: 0,
                filename: 'Query Metrics.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'pt', format: 'a4', orientation: 'landscape' }
              };
            
              // Convert the temporary container to PDF
              html2pdf().set(opt).from(pdfContainer).save();
        },    
        async viewRiskPopup(source){
            console.log("viewRiskPopup called with source:", source);
            this.showRiskListPopup = true;
            if(source === 'studyRisk'){
                this.riskListTitle = "High Risk Details Under Study";
                this.riskListData = this.studyRisk;
            } else if(source === 'siteRisk'){
                this.riskListTitle = "High Risk Details Under Site";
                this.riskListData = this.siteRisk;
            } else {
                this.riskListTitle = "Risk Details";
                this.riskListData = [];
            }
        },
        closeRiskModal(){
            console.log("closeRiskModal called");
            this.showRiskListPopup = false;
        }
    }
}